<template>
    <div class="full-overlay outer-center" :style="computedStyle">
        <div @click.self="$emit('click')" class="inner-center">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        backgroundColor: String
    },
    computed: {
        computedStyle() {
            if (this.backgroundColor) {
                return {
                    backgroundColor: this.backgroundColor
                };
            }
            return {};
        }
    }
}
</script>

<style scoped>
    .full-overlay {
        position: fixed;
        top: 0;
        right: 0;
        left: 0;
        bottom: 0;
        background-color: rgba(0, 0, 0, 0.5);
        z-index: 2147483647;
    }

    .outer-center {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-content: center;
    }

    .inner-center {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-content: center;
    }
</style>
